import {
  SwipeableDrawer,
  Typography,
  List,
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  InputBase,
  IconButton,
  InputLabel,
  FormControl,
  Backdrop,
  Button,
  Autocomplete,
  TextField,
  ListItemAvatar,
  Avatar,
  Grid,
  Divider,
  Skeleton,
} from "@mui/material";
import {
  PersonAdd,
  MonetizationOn,
  FeaturedPlayList,
  LocalOffer,
  Search,
  KeyboardBackspace,
  MoveToInbox,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";
import { useCallback, useRef, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import {
  listItemmasters,
  listPartymasters,
  listInvoiceMaster,
  listPurchaseMaster,
  listItemmastersv2,
  listPartymastersv2,
  listPartymastersv2Count,
  listInvoiceMasterCount,
  listPurchaseMasterCount,
  listItemmastersv2Count,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Chip from "@mui/material/Chip";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { MoneyFormatv2 } from "../../library/MoneyFormat";
import { Fragment } from "react";
import AddNewItemModal from "../../pages/PrimeFigma/Modals/AddNewItemModal";
import AddNewItem from "../../pages/PrimeFigma/ItemPage/AddNewItem";
import { useDebounce } from "../../hooks/useDebounce";
import {
  listInvoiceMasterv2Custom,
  listPurchaseMasterTestCustom,
} from "../../graphql/customQueries";
import { useDispatch, useSelector } from "react-redux";
import { updateTitle, updateViewTitle } from "../../redux/reducers/titleSlice";
import { handleFreeze } from "../../utils/common";
import { showSuccessSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../../components/Theme/theme";
import useControlledNavigation from "../../hooks/useControlledNavigation";

function GlobalSearch(props) {
  const { theme } = useThemes();

  const inputRef = useRef(null);
  const [selected, setSelected] = useState(props.props);
  const [searchText, setSearchText] = useState(props.props);
  const [viewModal, setViewModal] = useState();
  const [itemIdModal, setItemIdModal] = useState("");
  const navigate = useControlledNavigation();

  const filteringFn = (e, z) => {
    if (sort === "Start with") {
      let escapedPattern = selected
        ?.toUpperCase()
        .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      let pattern = new RegExp(`^${escapedPattern}`);
      if (pattern.test(e[z]?.toUpperCase())) {
        // setListVld(true)
        return e;
      }
    }
    if (sort === "Contain") {
      let escapedPattern = selected
        ?.toUpperCase()
        .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      let pattern = new RegExp(`${escapedPattern}`);
      if (pattern.test(e[z]?.toUpperCase())) {
        // setListVld(true)
        return e;
      }
    }
    if (sort === "Exact") {
      if (e[z].indexOf(selected) >= 0) {
        // setListVld(true)
        return e;
      }
    }
  };

  function handleOpen(item) {
    dispatch(
      updateTitle(JSON.stringify({ type: item.ItemType, name: item.ItemName }))
    );
    navigate("/viewitem", {
      state: {
        id: item.ItemID,
        view: true,
        type: item.ItemType == "SERVICE" ? 2 : 1,
      },
    });
    props.setOpen(false);
    // setViewModal(true)
    // setItemIdModal(item)
    // props.setOpen(false);
  }

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [filter, setFilter] = useState("All");
  const [sort, setSort] = useState("Start with");
  const [goodslist, setGoodsList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [partyList, setPartyList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [salesList, setSalesList] = useState([]);
  const [purchaseList, setPurchaseList] = useState([]);
  let [count, setCount] = useState({});
  const dispatch = useDispatch();

  const handleChange = (event) => {
    if (event.target.name === "Filter") {
      setSearchText("");
      search("");
      setFilter(event.target.value);
    } else {
      setSort(event.target.value);
    }
  };

  async function listPurchaseandExpence(value) {
    try {
      let array = API.graphql(
        graphqlOperation(listPurchaseMasterTestCustom, {
          RowFrom: 0,
          LimitNo: 6,
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([{ SupplierName: value }]),
        })
      );
      const resCount = API.graphql(
        graphqlOperation(listPurchaseMasterCount, {
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([{ SupplierName: value }]),
        })
      );
      Promise.all([array, resCount]).then((response) => {
        let res = response[0];
        let countRes = response[1];
        setPurchaseList(res.data.listPurchaseMasterTest);
        setCount((prev) => ({
          ...prev,
          purchase:
            countRes.data.listPurchaseMasterCount[0].PurchaseMasterListCount,
        }));
      });
      // const res = await API.graphql(graphqlOperation(listPurchaseMaster));
      // let Pdata = []
      // res.data.listPurchaseMaster.map((n) => {
      //   let pname = n.RelatedPartyMaster[0].PartyLegalName
      //   let customerOrSupplierType = n.RelatedPartyMaster[0].PartyTypeCd
      //   let data = { ...n, "customerOrSupplierType": customerOrSupplierType, "partyName": pname, }
      //   Pdata = [...Pdata, data]
      // })
      // setPurchaseList(Pdata)
    } catch (e) {
      console.log("error", e);
    }
  }
  async function listSalesInvoices(value) {
    try {
      let array = API.graphql(
        graphqlOperation(listInvoiceMasterv2Custom, {
          RowFrom: 0,
          LimitNo: 6,
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([
            { CustomerName: value },
            { InvoiceTypeCD: "SalesInvoice" },
          ]),
        })
      );
      const resCount = API.graphql(
        graphqlOperation(listInvoiceMasterCount, {
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([
            { CustomerName: value },
            { InvoiceTypeCD: "SalesInvoice" },
          ]),
        })
      );
      Promise.all([array, resCount]).then((response) => {
        let res = response[0];
        let countRes = response[1];
        setSalesList(res.data.listInvoiceMasterv2);
        setCount((prev) => ({
          ...prev,
          sales:
            countRes.data.listInvoiceMasterCount[0]?.InvoiceMasterListCount,
        }));
      });
    } catch (e) {
      console.log("error", e);
    }
  }
  async function getItemList(value, type) {
    try {
      let rr = await API.graphql(
        graphqlOperation(listItemmastersv2, {
          RowFrom: 0,
          LimitNo: 6,
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([
            { ItemName: value },
            { ItemType: type },
          ]),
        })
      );
      let resCount = API.graphql(
        graphqlOperation(listItemmastersv2Count, {
          RowFrom: 0,
          LimitNo: 10,
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([
            { ItemName: value },
            { ItemType: type },
          ]),
        })
      );
      Promise.all([rr, resCount]).then((response) => {
        let res = response[0];
        let countRes = response[1];
        if (type == "SERVICE") {
          setCount((prev) => ({
            ...prev,
            ser: countRes.data.listItemmastersv2Count[0].ItemCount,
          }));
          return setServiceList(res.data.listItemmastersv2);
        } else {
          setCount((prev) => ({
            ...prev,
            good: countRes.data.listItemmastersv2Count[0].ItemCount,
          }));
          return setGoodsList([...res.data.listItemmastersv2]);
        }
      });
      // const res = await API.graphql(
      //   graphqlOperation(listItemmasters)
      // )
      // let Pdata = []
      // rr.data.listItemmastersv2.map((n) => {
      //   Pdata = [...Pdata, data]
      // })
      // if (type == "SERVICE") {
      //   return setServiceList(rr.data.listItemmastersv2)
      // }
      // else
      //   return setGoodsList([...rr.data.listItemmastersv2])
    } catch (e) {
      console.log(e, "error");
    }
  }
  async function getPartyMasters(value, type) {
    try {
      let dataList = API.graphql(
        graphqlOperation(listPartymastersv2, {
          RowFrom: 0,
          LimitNo: 10,
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([
            { PartyLegalName: value },
            { PartyTypeCd: type },
          ]),
        })
      );
      let resActiveCount = API.graphql(
        graphqlOperation(listPartymastersv2Count, {
          ColumnName: "EnteredTimeStamp",
          OrderType: "DESC",
          SearchMode: 1,
          SearchArray: JSON.stringify([
            { PartyLegalName: value },
            { PartyTypeCd: type },
          ]),
        })
      );

      Promise.all([dataList, resActiveCount]).then((response) => {
        let res1 = response[0];
        let res2 = response[1];
        if (type == "CUSTOMER") {
          setCustomerList(res1.data?.listPartymastersv2);
          setCount((prev) => ({
            ...prev,
            customer: res2.data.listPartymastersv2Count[0].PartyCount,
          }));
        } else {
          setPartyList(res1.data.listPartymastersv2);
          setCount((prev) => ({
            ...prev,
            supplier: res2.data.listPartymastersv2Count[0].PartyCount,
          }));
        }
      });
      // const res = await API.graphql(graphqlOperation(listPartymasters));
    } catch {
      console.log("error");
    }
  }
  useEffect(() => {
    if (props.open) {
      inputRef?.current?.focus();
      inputRef?.current?.setSelectionRange(0, inputRef.current.value.length);
      listSalesInvoices("");
      getItemList(searchText, "GOODS");
      getItemList(searchText, "SERVICE");
      getPartyMasters(searchText, "CUSTOMER");
      getPartyMasters(searchText, "SUPPLIER");
      listPurchaseandExpence(searchText);
    } else {
      setFilter("All");
      setSelected("");
    }
    return () => {};
  }, [props.open]);
  let search = (obj) => {
    getItemList(obj, "GOODS");
    getItemList(obj, "SERVICE");
    getPartyMasters(obj, "SUPPLIER");
    getPartyMasters(obj, "CUSTOMER");
    listPurchaseandExpence(obj);
    listSalesInvoices(obj);
  };
  let [ripple, setRipple] = useState();
  let rippleFn = (obj) => {
    setRipple(obj);
  };
  const filterSearch = useCallback(
    useDebounce(
      (obj) => {
        rippleFn(obj);
      },
      400,
      true
    ),
    []
  );
  useEffect(() => {
    filterSearch(true);
    return () => {
      filterSearch(true);
    };
  }, [searchText, filterSearch]);

  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );

  const checkFreeze = (e, text) => {
    if (Freeze == 1) {
      e.preventDefault();
      return handleFreeze();
    } else if (text == "service") {
      e.preventDefault();
      navigate("/additem", { state: { type: 2 } });
    } else if (text !== "service") {
      e.preventDefault();
      navigate("/additem", { state: { type: 1 } });
    }
  };

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: 1200,
        backdropFilter: "blur(3px)",
        backgroundColor: "rgba(0,0,30,0.4)",
      }}
      open={props?.open}
    >
      <SwipeableDrawer
        anchor="right"
        onOpen={() => {}}
        open={props?.open}
        PaperProps={{
          style: {
            // top: 64, // Adjust the top value based on your custom position
            // left: "52%",
            // right: "5%",
            // height: "70%",
            // width: { xs: '250px', sm: '400px', md: "400px" }
          },
        }}
        onClose={() => {
          props.setOpen(false);
          setSort("Start with");
          setFilter("All");
        }}
      >
        <Box
          id="000000"
          sx={{
            padding: { xs: "10px", sm: "30px" },
            width: { xs: "250px", sm: "400px", md: "700px" },
          }}
          role="presentation"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <KeyboardBackspace
              style={{ cursor: "pointer" }}
              onClick={() => props.setOpen(false)}
              sx={{ fontSize: "30px", marginRight: 1, fontWeight: "0" }}
            />
            <Typography fontSize="18px" color={"#C8087F"}>
              Global Search
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Autocomplete
              sx={{
                m: 1,
                minWidth: 120,
                marginTop: "15px",
                marginBottom: "15px",
                marginRight: "0px",
              }}
              size="small"
              id="autocomplete-filter"
              options={[
                { label: "All", value: "All" },
                { label: "Items-Goods", value: "Items-Goods" },
                { label: "Items-Services", value: "Items-Services" },
                { label: "Customer", value: "Customer" },
                { label: "Supplier", value: "Supplier" },
                { label: "Invoice", value: "Invoice" },
              ]}
              getOptionLabel={(option) => option.label}
              onChange={(event, newValue) => {
                handleChange({
                  target: { name: "Filter", value: newValue?.value },
                });
              }}
              renderInput={(params) => (
                <TextField {...params} label="Search" variant="outlined" />
              )}
            />
            {/* <FormControl sx={{ m: 1, minWidth: 120, marginTop: '15px', marginBottom: '15px', marginLeft: '0px' }} size="sm">
              <InputLabel id="demo-select-sm-label">Sort</InputLabel>
              <Select
                labelId="demo-select-sm-label"
                id="demo-select-sm"
                defaultValue={"Start with"}
                size='small'
                // input={<OutlinedInput id="select-multiple-chip" label="Sort" />}
                value={sort}
                label="Sort"
                name="Sort"
                onChange={handleChange}
              // sx={{
              //   ".MuiInputBase-input": {
              //     padding: "8.5px 14px",
              //   },
              // }}
              >
                <MenuItem value={"Start with"}>Start with</MenuItem>
                <MenuItem value={"Contain"}>Contain</MenuItem>
                <MenuItem value={"Exact"}>Exact</MenuItem>

              </Select>
            </FormControl> */}
            <Paper
              sx={{
                background: "transparent",
                display: "flex",
                alignItems: "center",
                width: "50%",
                border: " 1px solid #C0C0C0",
                boxShadow: "none",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  // ".MuiInputBase-input": {
                  //   padding: "0.5px 14px",
                  // }
                }}
                size="small"
                placeholder="Enter Keyword to Search"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchText}
                inputRef={inputRef}
                // input={<OutlinedInput id="select-multiple-chip" label="Search" />}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              <Divider sx={{ height: "70%" }} orientation="vertical" />
              <IconButton
                disableRipple={false}
                onClick={() => {
                  setSelected(searchText);
                  search(searchText);
                }}
                type="button"
                sx={{
                  animation:
                    ripple == true
                      ? theme?.palette?.TmId.id.toString().includes("9")
                        ? "darkRipple 3s infinite"
                        : "lightRipple 3s infinite"
                      : "none", //lightRipple
                  padding: "0px 10px",
                  borderRadius: "5px",
                }}
                aria-label="search"
              >
                <Search />
              </IconButton>
            </Paper>
          </Box>

          {(filter === "Items-Goods" || filter === "All") && (
            <Box>
              {filter === "Items-Goods" && (
                <Box
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  <Typography
                    marginBottom={"10px"}
                    fontSize="15px"
                    color={"#6558F5"}
                  >
                    Items-Goods
                  </Typography>

                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Link
                      style={{ width: "50%", textDecoration: "none" }}
                      onClick={checkFreeze}
                      to={"/AddItem"}
                    >
                      <ListItem
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonAdd
                              sx={{ color: "#b5b5b5", fontSize: "15px" }}
                            />
                          </ListItemIcon>
                          <ListItemText sx={{ color: "#b5b5b5" }}>
                            <Typography marginLeft={-4} fontSize={"13px"}>
                              Add Item
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Grid>
                </Box>
              )}
              <Box
                className="itemParent"
                sx={{
                  marginTop: "10px",
                  ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                    padding: "8px 10px",
                  },
                }}
              >
                <Typography
                  className="itemHead"
                  display={filter !== "All" ? "block" : "none"}
                  marginBottom={"10px"}
                  fontSize="15px"
                >
                  Goods List
                </Typography>

                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {goodslist.map((item, index) => {
                    return (
                      <Box
                        key={index}
                        className="itemChild"
                        style={{ width: "30%", textDecoration: "none" }}
                        onClick={() => {
                          handleOpen(item);
                        }}
                      >
                        <List
                          key={index}
                          disablePadding
                          onClick={() => {
                            // navigate(item.nav);
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon>
                              <ListItemAvatar>
                                <Avatar
                                  sx={{ width: "30px", height: "30px" }}
                                  alt={item.ItemName}
                                  src={item.ImageURL}
                                />
                              </ListItemAvatar>
                            </ListItemIcon>
                            <ListItemText
                              primaryTypographyProps={{
                                ml: "-10px",
                                fontSize: "15px",
                                width: "85%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#8c8585",
                              }}
                              primary={item.ItemName}
                            />
                          </ListItemButton>
                        </List>
                      </Box>
                    );
                  })}
                </Grid>
                {count.good > 6 ? (
                  <IconButton
                    sx={{
                      fontSize: "12px",
                      borderRadius: "2px",
                      color: "#8c8585",
                    }}
                    disableRipple={false}
                    onClick={() => {
                      navigate("newItemList", { state: { search: selected } });
                      props.setOpen(false);
                    }}
                  >
                    <KeyboardDoubleArrowRight
                      sx={{ color: "#8c8585", fontSize: "20px", margin: "0px" }}
                    />{" "}
                    More
                  </IconButton>
                ) : null}
              </Box>
            </Box>
          )}

          {(filter === "Items-Services" || filter === "All") && (
            <Box>
              {filter === "Items-Services" && (
                <List
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  <Typography
                    marginBottom={"10px"}
                    fontSize="15px"
                    color={"#6558F5"}
                  >
                    Items-Services
                  </Typography>
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Link
                      style={{ width: "50%", textDecoration: "none" }}
                      onClick={(e) => {
                        checkFreeze(e, "service");
                      }}
                    >
                      <ListItem
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonAdd
                              sx={{ color: "#8c8585", fontSize: "15px" }}
                            />
                          </ListItemIcon>
                          <ListItemText sx={{ color: "#8c8585" }}>
                            <Typography marginLeft={-4} fontSize={"13px"}>
                              Add Item
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Grid>
                </List>
              )}
              <Box
                className="serviceParent"
                sx={{
                  marginTop: "10px",
                  ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                    padding: "8px 10px",
                  },
                }}
              >
                <Typography
                  className="serviceHead"
                  display={filter !== "All" ? "block" : "none"}
                  marginBottom={"10px"}
                  fontSize="15px"
                >
                  Services List
                </Typography>

                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {serviceList.map((item, index) => (
                    <Box
                      className="serviceChild"
                      style={{ width: "20%", textDecoration: "none" }}
                      onClick={() => {
                        handleOpen(item);
                      }}
                    >
                      <ListItem
                        key={index}
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <ChevronRightIcon
                              sx={{
                                color: "#8c8585",
                                fontSize: "20px",
                                margin: "0px",
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            primaryTypographyProps={{
                              ml: "-10px",
                              fontSize: "15px",
                              width: "85%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#8c8585",
                            }}
                            primary={item.ItemName}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Box>
                  ))}
                </Grid>
              </Box>
            </Box>
          )}
          {(filter === "Customer" || filter === "All") && (
            <Box>
              {filter === "Customer" && (
                <Box
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  {filter === "Customer" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        component="span"
                        fontSize="15px"
                        color={"#6558F5"}
                      >
                        Customer
                      </Typography>
                    </Box>
                  )}

                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Link
                      style={{ width: "50%", textDecoration: "none" }}
                      onClick={checkFreeze}
                      to={`/addcustomer`}
                    >
                      <ListItem
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonAdd
                              sx={{ color: "#8c8585", fontSize: "15px" }}
                            />
                          </ListItemIcon>
                          <ListItemText sx={{ color: "#8c8585" }}>
                            <Typography marginLeft={-4} fontSize={"13px"}>
                              Add Customer
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Grid>
                </Box>
              )}

              <Box>
                <Box
                  className="customerParent"
                  sx={{
                    marginTop: "10px",
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  <Typography
                    key={0}
                    className="customerHead"
                    marginBottom={"10px"}
                    display={filter !== "All" ? "block" : "none"}
                    fontSize="15px"
                  >
                    Customers List
                  </Typography>

                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    {customerList.map((item, index) => (
                      <Box
                        className="customerChild"
                        style={{ width: "20%", textDecoration: "none" }}
                        onClick={() => {
                          navigate("/viewcustomer", {
                            state: { id: item.PartyID, view: true },
                          });
                        }}
                      >
                        <ListItem
                          key={index}
                          disablePadding
                          onClick={() => {
                            // navigate(item.nav);
                            props.setOpen(false);
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon>
                              <ChevronRightIcon
                                sx={{
                                  color: "#8c8585",
                                  fontSize: "20px",
                                  margin: "0px",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primaryTypographyProps={{
                                ml: "-10px",
                                fontSize: "15px",
                                width: "85%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#8c8585",
                              }}
                              primary={item.PartyDisplayName}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Box>
                    ))}
                  </Grid>
                  {count.customer > 10 ? (
                    <IconButton
                      sx={{
                        fontSize: "12px",
                        borderRadius: "2px",
                        color: "#8c8585",
                      }}
                      disableRipple={false}
                      onClick={() => {
                        navigate("customerList", {
                          state: { search: selected },
                          replace: true,
                        });
                        props.setOpen(false);
                      }}
                    >
                      <KeyboardDoubleArrowRight
                        sx={{
                          color: "#8c8585",
                          fontSize: "20px",
                          margin: "0px",
                        }}
                      />{" "}
                      More
                    </IconButton>
                  ) : null}
                </Box>
              </Box>
            </Box>
          )}
          {(filter === "Supplier" || filter === "All") && (
            <Box>
              <Box
                sx={{
                  ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                    padding: "8px 10px",
                  },
                }}
              >
                {filter === "Supplier" && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      component="span"
                      fontSize="15px"
                      color={"#6558F5"}
                    >
                      Supplier
                    </Typography>
                  </Box>
                )}
                {filter !== "All" && (
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Link
                      style={{ width: "50%", textDecoration: "none" }}
                      onClick={checkFreeze}
                      to={`/addsupplier`}
                    >
                      <ListItem
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonAdd
                              sx={{ color: "#8c8585", fontSize: "15px" }}
                            />
                          </ListItemIcon>
                          <ListItemText sx={{ color: "#8c8585" }}>
                            <Typography marginLeft={-4} fontSize={"13px"}>
                              Add supplier
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Grid>
                )}
              </Box>

              <Box>
                <Box
                  className="su_parent"
                  sx={{
                    marginTop: "10px",
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  <Typography
                    className="su_head"
                    marginBottom={"10px"}
                    display={filter !== "All" ? "block" : "none"}
                    fontSize="15px"
                  >
                    Suppliers List
                  </Typography>

                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    {partyList.map((item, index) => (
                      <Box
                        className="su_child"
                        style={{ width: "20%", textDecoration: "none" }}
                        onClick={() => {
                          navigate("/viewsupplier", {
                            state: { id: item.PartyID, view: true },
                          });
                        }}
                      >
                        <ListItem
                          key={index}
                          disablePadding
                          onClick={() => {
                            // navigate(item.nav);
                            props.setOpen(false);
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon>
                              <ChevronRightIcon
                                sx={{
                                  color: "#8c8585",
                                  fontSize: "20px",
                                  margin: "0px",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primaryTypographyProps={{
                                ml: "-10px",
                                fontSize: "15px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "#8c8585",
                              }}
                              primary={item.PartyDisplayName}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Box>
                    ))}
                  </Grid>
                  {count.supplier > 10 ? (
                    <IconButton
                      sx={{
                        fontSize: "12px",
                        borderRadius: "2px",
                        color: "#8c8585",
                      }}
                      disableRipple={false}
                      onClick={() => {
                        navigate("supplierList", {
                          state: { search: selected },
                        });
                        props.setOpen(false);
                      }}
                    >
                      <KeyboardDoubleArrowRight
                        sx={{
                          color: "#8c8585",
                          fontSize: "20px",
                          margin: "0px",
                        }}
                      />{" "}
                      More
                    </IconButton>
                  ) : null}
                </Box>
              </Box>
            </Box>
          )}

          {(filter === "Invoice" || filter === "All") && (
            <Box>
              {filter === "Invoice" && (
                <Box
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      component="span"
                      fontSize="15px"
                      color={"#6558F5"}
                    >
                      Invoice
                    </Typography>
                  </Box>

                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Link
                      style={{ width: "50%", textDecoration: "none" }}
                      onClick={checkFreeze}
                      to={`/addnewinvoicetax`}
                    >
                      <ListItem
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonAdd
                              sx={{ color: "#8c8585", fontSize: "15px" }}
                            />
                          </ListItemIcon>
                          <ListItemText sx={{ color: "#8c8585" }}>
                            <Typography marginLeft={-4} fontSize={"13px"}>
                              Add Invoice
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Grid>
                </Box>
              )}

              <Box
                className="ci_parent"
                sx={{
                  marginTop: "10px",
                  ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                    padding: "8px 10px",
                  },
                }}
              >
                <Typography
                  className="ci_head"
                  marginBottom={"10px"}
                  display={filter !== "All" ? "block" : "none"}
                  fontSize="15px"
                >
                  Sales Invoice List
                </Typography>

                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {salesList.map((item, index) => (
                    <Box
                      className="ci_child"
                      style={{ width: "48%", textDecoration: "none" }}
                      onClick={() => {
                        dispatch(
                          updateViewTitle(
                            item.CancelFlag == 1
                              ? { type: "Cancelled", name: item.InvoiceNumber }
                              : { type: "", name: item.InvoiceNumber }
                          )
                        );
                        const path =
                          item.InvoiceTaxableTypeCD === "TAXABLE"
                            ? "/viewnewinvoicetax"
                            : "/viewinvoiceNonTaxable";
                        navigate(path, {
                          state: {
                            id: item.InvoiceID,
                            view: true,
                            key: item.InvoiceID,
                          },
                        });
                      }}
                    >
                      <ListItem
                        key={index}
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <ChevronRightIcon
                              sx={{
                                color: "#8c8585",
                                fontSize: "20px",
                                margin: "0px",
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{ color: "#8c8585" }}
                            primary={item.ConsigneeName}
                            primaryTypographyProps={{
                              ml: "-10px",
                              fontSize: "15px",
                              width: "85%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: "#8c8585",
                            }}
                            secondary={
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  marginLeft: "0px",
                                }}
                              >
                                <Fragment>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="#8c8585"
                                  >
                                    <i>Invoice: </i>
                                    {item.InvoiceNumber}
                                  </Typography>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="#8c8585"
                                  >
                                    <i>Amount: </i>
                                    {MoneyFormatv2(item.InvoiceAmount)}
                                  </Typography>
                                </Fragment>
                              </Box>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    </Box>
                  ))}
                </Grid>
                {count.sales > 6 ? (
                  <IconButton
                    sx={{
                      fontSize: "12px",
                      borderRadius: "2px",
                      color: "#8c8585",
                    }}
                    disableRipple={false}
                    onClick={() => {
                      navigate("salesInvoiceReport", {
                        state: { search: selected },
                        replace: true,
                      });
                      props.setOpen(false);
                    }}
                  >
                    <KeyboardDoubleArrowRight
                      sx={{ color: "#8c8585", fontSize: "20px", margin: "0px" }}
                    />{" "}
                    More
                  </IconButton>
                ) : null}
              </Box>
              {filter === "Invoice" && (
                <Box
                  sx={{
                    ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                      padding: "8px 10px",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      component="span"
                      fontSize="15px"
                      color={"#6558F5"}
                    >
                      Purchase Invoice
                    </Typography>
                  </Box>

                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Link
                      style={{ width: "50%", textDecoration: "none" }}
                      onClick={checkFreeze}
                      to={`/addnewpurchasetax`}
                    >
                      <ListItem
                        disablePadding
                        onClick={() => {
                          // navigate(item.nav);
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonAdd
                              sx={{ color: "#8c8585", fontSize: "15px" }}
                            />
                          </ListItemIcon>
                          <ListItemText sx={{ color: "#8c8585" }}>
                            <Typography marginLeft={-4} fontSize={"13px"}>
                              Add Invoice
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Grid>
                </Box>
              )}
              <Box
                className="si_parent"
                sx={{
                  marginTop: "10px",
                  ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                    padding: "8px 10px",
                  },
                }}
              >
                <Typography
                  className="si_head"
                  marginBottom={"10px"}
                  display={filter !== "All" ? "block" : "none"}
                  fontSize="15px"
                >
                  Purchase Invoice List
                </Typography>
                <Grid
                  className="si_parent"
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {purchaseList.map((item, index) => (
                    <Box
                      className="si_child"
                      style={{ width: "48%", textDecoration: "none" }}
                      onClick={() => {
                        dispatch(
                          updateViewTitle(
                            item.CancelFlag == 1
                              ? { type: "Cancelled", name: item.VoucherNumber }
                              : { type: "", name: item.VoucherNumber }
                          )
                        );
                        navigate(
                          `${
                            item.PurchaseGSTTypeCD === "TAXABLE"
                              ? "/viewnewpurchasetax"
                              : "/viewpurchaseandexpensenontaxable"
                          }`,
                          { state: { id: item.PurchaseID, view: true } }
                        );
                      }}
                    >
                      <ListItem
                        key={index}
                        disablePadding
                        onClick={() => {
                          props.setOpen(false);
                        }}
                      >
                        <ListItemButton>
                          <ListItemIcon>
                            <ChevronRightIcon
                              sx={{
                                color: "#8c8585",
                                fontSize: "20px",
                                margin: "0px",
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{ color: "lack" }}
                            primary={item.PartyDisplayName}
                            primaryTypographyProps={{
                              ml: "-10px",
                            }}
                            secondary={
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  marginLeft: "0px",
                                }}
                              >
                                <Fragment>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="#8c8585"
                                  >
                                    <i>Invoice: </i>
                                    {item.VoucherNumber}
                                  </Typography>
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="#8c8585"
                                  >
                                    <i>Amount: </i>
                                    {MoneyFormatv2(item.GrantTotalAmount)}
                                  </Typography>
                                </Fragment>
                              </Box>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    </Box>
                  ))}
                </Grid>
                {count.purchase > 6 ? (
                  <IconButton
                    sx={{
                      fontSize: "12px",
                      borderRadius: "2px",
                      color: "#8c8585",
                    }}
                    disableRipple={false}
                    onClick={() => {
                      navigate("allpurchaseandexpense", {
                        state: { search: selected },
                        replace: true,
                      });
                      props.setOpen(false);
                    }}
                  >
                    <KeyboardDoubleArrowRight
                      sx={{ color: "#8c8585", fontSize: "20px", margin: "0px" }}
                    />{" "}
                    More
                  </IconButton>
                ) : null}
              </Box>
            </Box>
          )}
          {(
            filter == "All"
              ? count.customer == 0 &&
                count.supplier == 0 &&
                count.sales == 0 &&
                count.purchase == 0 &&
                count.good == 0 &&
                count.ser == 0
              : filter == "Items-Goods"
              ? count.good == 0
              : filter == "Items-Services"
              ? count.ser == 0
              : filter == "Customer"
              ? count.customer == 0
              : filter == "Supplier"
              ? count.supplier == 0
              : filter == "Invoice" && count.sales == 0 && count.purchase == 0
          ) ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No Data Found
            </Box>
          ) : null}
        </Box>
      </SwipeableDrawer>
      {viewModal === true && (
        <AddNewItemModal
          open={viewModal}
          setOpen={setViewModal}
          modalEvent={true}
          // setItemID={setItemID}
          itemID={itemIdModal.ItemID}
          itemType={itemIdModal.ItemType}
          page={itemIdModal.ItemType}
        />
      )}
    </Backdrop>
  );
}

export default GlobalSearch;
